import { IconFacebook, IconInstagram, IconLinkedin, IconTwitterX, IconYoutube } from '@/components/icons/SocialIcons';

type SocialLink = {
    name: string; 
    links: string;
};

type SocialLinksProps = {
    className?: string;
    social?: SocialLink[];
};

const iconMap: Record<string, React.ComponentType<{ className?: string }>> = {
    facebook: IconFacebook,
    twitter: IconTwitterX,
    instagram: IconInstagram,
    linkedin: IconLinkedin,
    youtube: IconYoutube,
};

const SocialLinks = ({ className, social = [] }: SocialLinksProps) => {
    return (
        <ul className={`flex gap-6 items-center ${className}`}>
            {social.map((item, index) => {
                const IconComponent = iconMap[item.name.toLowerCase()];
                if (!IconComponent) return null; // تجاهل إذا لم يكن هناك أيقونة مطابقة

                return (
                    <li key={index}>
                        <a href={item.links} target="_blank" rel="noreferrer">
                            <IconComponent
                                className={`w-fit ${
                                    item.name.toLowerCase() === 'youtube'
                                        ? 'lg:h-[45px] h-8 mb-[-3px]'
                                        : 'lg:h-8 md:h-7 h-6'
                                } dark:text-Grey20 text-bg-logo`}
                            />
                        </a>
                    </li>
                );
            })}
        </ul>
    );
};

export default SocialLinks;
